<template>
  <div class="flex-right">
    <input
      style="display: none"
      type="file"
      ref="importInput"
      @change="handleImportFileSelect"
      accept="application/json">
    <v-btn color='secondary' class='mb-2' @click="importAll" text>
      {{$t('button.import')}}
    </v-btn>
    /
    <v-btn color='secondary' class='mb-2' @click="exportAll" text>
      {{$t('core.import_export.export')}}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'ImportExport',
  props: {
    rootClass: {
      type: String,
      default: 'flex-right'
    }
  },
  methods: {
    importAll () {
      const input = this.$refs.importInput
      input.click()
    },
    handleImportFileSelect (event) {
      const files = event.target.files
      if (files.length === 1) {
        this.$emit('import', files[0])
      }
      event.target.value = ''
    },
    exportAll () {
      confirm(this.$t('warnings.confirm.export')) && this.$emit('export')
    }
  }
}
</script>
